<template>
  <div v-loading="loading">
    <div class="header">
      <el-button @click="$router.go(-1)"><img src="@/assets/images/icons/arrow-left.svg">Ortga</el-button>
      <el-button type="primary"
                 @click="$router.push({name: 'ChronologyAdd', params:{initiativeId}, query: $route.query})">Xronologiya
        qo'shish
      </el-button>
    </div>
    <el-table :data="tableData" border height="calc(100vh - 210px)">
      <el-table-column type="index" label="T/r"/>
      <el-table-column prop="chronology_type" label="Xronologiya turi"/>
      <el-table-column prop="lot_number" label="Lot raqami"/>
      <el-table-column prop="contract_code" label="Shartnoma kodi"/>
      <el-table-column prop="contract_time" label="Shartnoma sanasi">
        <template #default="scope">{{ $moment(scope.row.contract_time).format('DD.MM.YYYY') }}</template>
      </el-table-column>
      <el-table-column prop="orderer_title" label="Buyurtmachi nomi"/>
      <el-table-column prop="contractor_title" label="Pudratchi nomi"/>
      <el-table-column width="190">
        <template #default="scope">
          <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">O'chirish</el-button>
          <el-button size="small" type="primary" @click="handleEdit(scope.row.id)">Tahrirlash</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";

export default {
  name: "ChronologyList",
  data() {
    return {
      loading: false,
      tableData: [],
      initiativeId: null
    }
  },
  methods: {
    handleEdit(id) {
      this.$router.push({
        name: 'ChronologyEdit',
        params: {initiativeId: this.initiativeId},
        query: {...this.$route.query, edit_id: id}
      })
    },
    handleDelete(id) {

      ElMessageBox.confirm(
          'Xronologiyani o\'chirasizmi?',
          'Diqqat!',
          {
            confirmButtonText: 'Ha',
            cancelButtonText: 'Bekor qilish',
            type: 'warning',
          }
      )
          .then(() => {
            this.loading = true
            this.$http.delete(`/api/v1/chronology/${id}`).then(() => {
              ElMessage({
                type: 'success',
                message: 'Xronologiya o\'chirildi',
              })
              this.getQuarterList();
            }).catch(() => {
              ElNotification({
                type: 'error',
                title: 'Xatolik',
                message: 'Iltimos, qayta urinib ko\'ring',
              })
            }).finally(() => {
              this.loading = false
            })

          })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: 'O\'chirish bekor qilindi',
            })
          })
    },
    getChronologyList() {
      this.loading = true
      this.$http.get(`api/v1/chronology?initiative_id=${this.initiativeId}`).then(({data}) => {
        this.tableData = data
      }).catch(({response}) => {
        ElNotification.error({
          message: response.data.message || "Ma'lmumot yuklasda xatolik sodir bo'ldi!"
        })
      }).finally(() => {
        this.loading = false
      })
    },
  },
  mounted() {
    if (this.$route.params.initiativeId) {
      this.initiativeId = this.$route.params.initiativeId
      this.getChronologyList()
    }
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  gap: 10px;
}
</style>